module.exports = __webpack_public_path__ + "public/img/xunfeiTower.6521651f.png";